import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Button = styled.button`
  width: 100%;
  min-height: 28px;
  max-width: ${({ customWidth }) => customWidth || '70px'};
  background-color: ${({ customColor }) => customColor || '#007AFF'};
  border-radius: 49px;
  border: none;
  margin: ${({ customMargin }) => customMargin || '0'};
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: #ffffff;
  position: relative;
  transition: background-color 0.3s;

  &:focus {
    outline: none;
  }

  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }

  &:disabled {
    opacity: 0.5;

    &:hover {
      cursor: default;
    }
  }
`;

const AppButton = ({
  onClick,
  children,
  disabled,
  customText,
  customMargin,
  customColor,
  customWidth,
  customId,
}) => {
  const { t } = useTranslation();
  const customInner = customText || 'get';
  const onClickFunc = () => {
    if (disabled) return;
    onClick();
  };
  const btn = (
    <Button
      onClick={onClickFunc}
      disabled={disabled}
      customColor={customColor}
      customMargin={customMargin}
      customWidth={customWidth}
      id={customId || 'get-button'}
    >
      {children || t(customInner)}
    </Button>
  );
  return btn;
};
export default AppButton;
